export default __webpack_public_path__ + "img/8db46856e81193214dc5ef518e336743.png";